import installer from './defaults'

export * from '@unpack-ui/utils'
export * from '@unpack-ui/hooks'
export * from '@unpack-ui/components'
export * from './make-installer'

export const install = installer.install
export const version = installer.version

export default installer
